/* src/app/shared/components/renewal-popup/renewal-popup.component.scss */
.renewal-popup {
  padding: 1rem;
}
.renewal-popup .btn-block {
  padding-top: 1rem;
  display: flex;
  gap: 1rem;
}
.renewal-popup .btn-block ods-button {
  flex: 1;
}
/*# sourceMappingURL=renewal-popup.component.css.map */
